'use client';

import useIsPageInteractive from '@/hooks/useIsPageInteractive';
import dynamic from 'next/dynamic';

const GoogleAnalytics = dynamic(() => import('./GoogleAnalytics'), { ssr: false });

export default function LazyGoogleAnalytics(props) {
  const isPageInteractive = useIsPageInteractive();
  return isPageInteractive ? <GoogleAnalytics {...props} /> : null;
}
